module.exports = __webpack_public_path__ + "static/media/3DPPA25.e41f2e87.jpg";